import React, { useMemo, useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { API_BASE_URL } from '../config/apiBase';
import { consoleNavItems, filterNavByPermission } from './consoleNav';
import { isAiRiggingUiEnabled } from '../features/aiRigging';
import PartnerSwitcher from './PartnerSwitcher';
import ConsoleSwitcher from './ConsoleSwitcher';
import '../components/product.css';
import './console.css';

const API_URL = API_BASE_URL;

function ConsoleLayout() {
  const navigate = useNavigate();
  const {
    setIsAuthenticated,
    hasTenantPermission,
    user,
    aiRiggingFlags,
    capabilitiesLoaded,
  } = useAuth();
  const [collapsed, setCollapsed] = useState(false);

  const aiRiggingEnabled =
    capabilitiesLoaded && aiRiggingFlags != null
      ? Boolean(aiRiggingFlags.ai_rigging_enabled)
      : isAiRiggingUiEnabled();

  const visibleNav = useMemo(
    () =>
      filterNavByPermission(consoleNavItems, hasTenantPermission, {
        aiRiggingEnabled,
      }),
    [hasTenantPermission, aiRiggingEnabled]
  );

  const logout = async (event) => {
    event.preventDefault();
    try {
      await fetch(`${API_URL}/logout/`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (error) {
      // Still clear local auth state if the session is already gone.
    }
    setIsAuthenticated(false);
    navigate('/login');
  };

  return (
    <div className="console-shell">
      <aside className={`console-sidebar${collapsed ? ' collapsed' : ''}`}>
        <div className="console-sidebar-header">
          <NavLink to="/console" className="console-brand">
            <span className="console-brand-text">Partner Console</span>
          </NavLink>
          <button
            type="button"
            className="console-collapse-btn d-none d-md-inline"
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            onClick={() => setCollapsed((v) => !v)}
          >
            {collapsed ? '»' : '«'}
          </button>
        </div>
        <nav className="console-sidebar-nav" aria-label="Partner Console navigation">
          {visibleNav.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) =>
                `console-nav-link${isActive ? ' active' : ''}`
              }
            >
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="console-sidebar-footer">
          {!collapsed && user && (
            <div className="small text-secondary mb-2">{user.email}</div>
          )}
          <Button variant="outline-light" size="sm" onClick={logout}>
            Log out
          </Button>
        </div>
      </aside>
      <div className="console-main">
        <header className="console-topbar">
          <div className="console-topbar-left">
            <PartnerSwitcher />
          </div>
          <div className="console-topbar-right">
            <ConsoleSwitcher />
          </div>
        </header>
        <main className="console-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default ConsoleLayout;
